<style lang="scss" scoped>
@keyframes alert {
  0% {
    border: 4px solid #3e88c9;
    color: #3e88c9;
  }
  50% {
    border: 4px solid #a94442;
    color: #a94442;
  }
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .file-upload {
    height: 200px;
    width: 200px;
    border-radius: 100px;
    position: relative;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;
    background-size: 100% 200%;
    transition: all 1s;
    font-size: 100px;
    border: 4px solid #3e88c9;
    color: #3e88c9;
    &.invalid-input {
      animation: alert 2s;
    }

    input[type='file'] {
      height: 200px;
      width: 200px;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      padding: 20px 0px;
    }

    input::after {
        content:'';
        cursor:pointer;
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        display:block;
    }

    &:hover {
      background-position: 0 100%;
      color: #FFF;
    }
  }
}

.no-img-bg {
  background-image: linear-gradient(to bottom, #FFFFFF 50%, #3e88c9 50%);
  margin-top: 27px;
  margin-bottom: 27px;
}
</style>

<template>
  <b-modal
    hide-footer
    ref="modal"
    id="profile-picture-modal"
    header-class="anchor-modal"
    title="Change your profile picture"
    size="md"
  >
    <b-row>
      <b-col>
        <div class="wrapper">
          <div
            class="file-upload raised"
            :class="{
              'no-img-bg': !image,
              'invalid-input': error,
            }"
            :style="imageStyle"
            v-b-tooltip.hover v-b-tooltip.right
            :title="image? '' : 'Click here or drag and drop picture.'"
          >
            <input
              ref="fileInput"
              type="file"
              @click="error = null"
              @change="onFileChange($event.target.name, $event.target.files)"
              :accept="allowedImageTypes.join(',')"
            >

            <font-awesome-icon v-if="!url" icon="upload"/>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="user.picture" class="text-center mt-2 mb-2">
      <b-col class="text-center mt-3">
        <b-button @click="removeProfilePicture" class="btn-danger raised">
          Remove Current Picture
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="error || image" class="text-center mt-2 mb-2">
      <b-col v-if="error" class="text-center text-danger">
        {{ error }}
      </b-col>
      <b-col v-else class="text-center mt-3">
        <b-button class="btn-danger raised" @click="setData(null, null)">Clear</b-button>
        <b-button class="btn-anchor raised" @click="submit">Submit</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { DEFINE_USER_PICTURE_PROFILE } from '@/vuex/types/actions';

library.add([faUpload]);

export default {
  data() {
    return {
      image: null,
      url: null,
      maxSize: 1024,
      error: null,
      allowedImageTypes: ['image/png', 'image/bmp', 'image/jpeg', 'image/jpg', 'image/svg+xml'],
    };
  },
  computed: {
    imageStyle() {
      if (this.url) {
        return {
          'background-image': `url('${this.url}')`,
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'background-size': 'cover',
        };
      }

      return {};
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    setData(image, error) {
      this.image = image || null;
      this.error = error || null;

      if (this.image) {
        const reader = new FileReader();
        reader.readAsDataURL(this.image);
        reader.onload = (e) => {
          this.url = e.target.result;
        };
      } else {
        this.url = null;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
      }
    },
    onFileChange(fieldName, file) {
      if (file && file.length > 0) {
        const imageFile = file[0];
        const size = imageFile.size / (this.maxSize * this.maxSize);
        if (!this.allowedImageTypes.includes(imageFile.type)) {
          this.setData(null, 'Please choose an image file.  (Accepting.png .bmp .jpg .svg)');
        } else if (size > 25) {
          this.setData(null, 'Your file is too big, please select an image under 25MB.');
        } else {
          this.setData(imageFile, null);
        }
      } else {
        this.setData();
      }
    },
    removeProfilePicture() {
      this.$reqs.post(`users/${this.user.id}/delete_profile_picture`)
        .then((response) => {
          if (response.status === 200) {
            this.$store.dispatch(DEFINE_USER_PICTURE_PROFILE, { picture: null });
            this.$notify({ group: 'alert', text: 'Profile picture deleted successfully' });
            this.$refs.modal.hide();
          }
        });
    },
    submit() {
      this.$reqs.upload(`users/${this.user.id}/upload_profile_picture`, { file: this.image })
        .then((response) => {
          this.$store.dispatch(
            DEFINE_USER_PICTURE_PROFILE,
            { picture: response.data.profile_picture },
          );
          this.$notify({ group: 'alert', text: 'Profile picture saved successfully' });
          this.$refs.modal.hide();
        })
        .catch((error) => {
          this.$emit('error', error.data);
        });
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent) => {
      /* Reset model when modal is hidden */
      if (bvEvent.target.id === 'profile-picture-modal') {
        this.setData();
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/tabs/change_profile_picture/ProfilePictureModal.vue